'use strict'

import { Model } from '@vuex-orm/core'

export default class ResiduaryEstateBeneficiary extends Model {
  static get entity () { return 'residuaryEstateBeneficiaries' }
  static get primaryKey () { return ['willId', 'beneficiaryId'] }

  static fields () {
    return {
      willId: this.attr(null),
      beneficiaryId: this.attr(null)
    }
  }
}
